import * as z from "zod";
import { MarketingAgentAnalyticsInputSchema } from "./common";

const LlmCostTimeSeriesPointSchema = z.object({
  date: z.string(), // YYYY-MM-DD format
  sentinelCost: z.number(),
  vanguardCost: z.number(),
  emailWriterCost: z.number(),
  smsWriterCost: z.number(),
  totalCost: z.number(),
});

export const getMarketingAgentLlmCostTrends = {
  name: "getMarketingAgentLlmCostTrends" as const,
  input: MarketingAgentAnalyticsInputSchema,
  output: z.array(LlmCostTimeSeriesPointSchema),
};
